import { render, staticRenderFns } from "./ClientChatbot.vue?vue&type=template&id=5fbffe3b"
import script from "./ClientChatbot.vue?vue&type=script&lang=js"
export * from "./ClientChatbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports